import { render, staticRenderFns } from "./PmRewardEdit.vue?vue&type=template&id=ff8c830a"
import script from "./PmRewardEdit.vue?vue&type=script&lang=js"
export * from "./PmRewardEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports